/** @ignore *//** exclude this module from typedoc generator */

/**
 * @description fix for Error: Uncaught ReferenceError: regeneratorRuntime is not defined
 * @see {@link https://dev.to/hulyakarakaya/how-to-fix-regeneratorruntime-is-not-defined-doj}
 */
import 'regenerator-runtime/runtime';
import { Measure } from '@cbsi-cbscom/measure';
import { setupPlayerServicesNamespace } from 'library/ts/namespaces/PlayerServices';
import { Metrics } from 'library/ts/utilities/measure/Metrics';
import { initializePolyfills } from 'library/ts/utilities/Polyfill';
import { ISmartTag } from 'tag/ts/smart_tag/interfaces/ISmartTag';
import { IWebCBS } from 'tag/ts/smart_tag/interfaces/web/IWebCBS';
import { SmartTag } from 'tag/ts/smart_tag/SmartTag';

Measure.start( Metrics.importToCreateTime );

// init polyfills
initializePolyfills();

/**
 * @description CBS page namespace
 */
declare global {
	interface Window {
		CBS: IWebCBS
	}
}

declare global {
	interface Window {
		/**
		 * @description declare SmartTag global namespace
		 * @see {ISmartTag}
		 */
		SmartTag: ISmartTag;
	}
}

// instantiate PlayerServices namespace
setupPlayerServicesNamespace()
	.then(
		( namespace ) => {
			// instantiate SmartTag class
			window.SmartTag = window.SmartTag || new SmartTag( namespace );
		}
	)
	.catch( ( error ) => {
		console.error( 'Smart Tag initialization failed:', error );

		// Prevent unhandled promise rejection by providing fallback
		// This ensures the application can still function in degraded mode
		// and prevents memory accumulation from unhandled rejections
		if ( typeof window !== 'undefined' && !window.SmartTag ) {
			// Create minimal fallback SmartTag interface to prevent page crashes
			// Using 'unknown' first for safe type assertion as recommended by TypeScript
			window.SmartTag = {
				name: 'SmartTag (Failed)',
				create: () => Promise.reject( new Error( 'Smart Tag initialization failed' ) ),
				remove: () => Promise.reject( new Error( 'Smart Tag initialization failed' ) ),
				reset: () => Promise.reject( new Error( 'Smart Tag initialization failed' ) )
			} as unknown as ISmartTag;
		}
	} );